import React from 'react'
import type { BaseAndRequestedValue } from './createDataPointsValue'
import { createDataPointsValue } from './createDataPointsValue'
import DataPointIndicator from './DataPointIndicator'

const DataPointsCell = React.memo(function DataPointsCell(props: BaseAndRequestedValue) {
  const value = createDataPointsValue(props)
  if (!value) return null
  return <DataPointIndicator value={value} />
})

export default DataPointsCell
